import React from 'react';
import {useIntl} from 'react-intl';
import TableMetronic from '../../../../../app/common/components/table/TableMetronic';
import styles from './technical-info.module.scss';
import clsx from 'clsx';
import { PageTitle } from '../../../../../_metronic/layout/core';

const TechnicalInfo = (): JSX.Element => {
  const intl = useIntl();

  const columns = [
    {
      accessorKey: 'label',
      header: intl.formatMessage({id: 'TECH_INFO.COL.INFO'}),
      cell: (info:any) => info.getValue(),
    },
    {
      accessorKey: 'value',
      header: intl.formatMessage({id: 'TECH_INFO.COL.VALUE'}),
      cell: (info:any) => info.getValue(),
    },
  ];

  const principalesInfos = [
    { label: intl.formatMessage({id: 'TECH_INFO.DNS.PRIMARY'}),   value: "83.142.144.246" },
    { label: intl.formatMessage({id: 'TECH_INFO.DNS.SECONDARY'}), value: "83.142.144.249" },
    { label: intl.formatMessage({id: 'TECH_INFO.NTP.PRIMARY'}),   value: "83.142.144.230" },
    { label: intl.formatMessage({id: 'TECH_INFO.NTP.SECONDARY'}), value: "83.142.144.231" },
    { label: intl.formatMessage({id: 'TECH_INFO.PROXY'}),         value: "proxy.celeste.fr, port 3128" },
  ];

  const mailInfos = [
    { label: intl.formatMessage({id: 'TECH_INFO.SMTP'}),    value: "smtp.celeste.fr port 25" },
    { label: intl.formatMessage({id: 'TECH_INFO.POP'}),     value: "pop.celeste.fr port 110" },
    { label: intl.formatMessage({id: 'TECH_INFO.IMAP'}),    value: "imap.celeste.fr port 143" },
    { label: intl.formatMessage({id: 'TECH_INFO.WEBMAIL'}), value: "http://webmail.celeste.fr" },
  ];

  const zimbraInfos = [
    { label: intl.formatMessage({id: 'TECH_INFO.SMTP.ZIMBRA'}),    value: "zm-smtp.celeste.fr port 25" },
    { label: intl.formatMessage({id: 'TECH_INFO.POP.ZIMBRA'}),     value: "zm-pop.celeste.fr port 110" },
    { label: intl.formatMessage({id: 'TECH_INFO.IMAP.ZIMBRA'}),    value: "zm-imap.celeste.fr port 143" },
    { label: intl.formatMessage({id: 'TECH_INFO.WEBMAIL.ZIMBRA'}), value: "http://zimbra.celeste.fr" },
  ];

  return <>
    <PageTitle>{intl.formatMessage({id: 'INFO_TECHNICAL'})}</PageTitle>
    <div className={clsx(styles.containertechInfo, 'col-12 col-xl-7')}>
      <TableMetronic
        title={intl.formatMessage({id: 'TECH_INFO.TABLE.MAIN'})}
        data={principalesInfos}
        columns={columns}
        searchBar={false}
      />
      <br/>

      <TableMetronic
        title={intl.formatMessage({id: 'TECH_INFO.TABLE.MAIL'})}
        data={mailInfos}
        columns={columns}
        searchBar={false}
      />
      <br/>

      <TableMetronic
        title={intl.formatMessage({id: 'TECH_INFO.TABLE.ZIMBRA'})}
        data={zimbraInfos}
        columns={columns}
        searchBar={false}
      />
    </div>
  </>;
};

export default TechnicalInfo;
